import React, { Component } from "react";

import {
  Grid,
  Row,
  Col,
  Alert,
  FormGroup,
  ControlLabel
} from "react-bootstrap";

import { Query, Mutation } from "react-apollo";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';

import { Card } from "../../components/Card/Card.jsx";
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";
import { GoogleLogin } from 'react-google-login';

import InputMask from 'react-input-mask';

import header_mobile from "../../assets/img/header-mobile.jpg";
import header_desktop from "../../assets/img/header-desktop.jpg";


const restLink_account = new HttpLink({ credentials: 'include', uri: "/api/v1/account/" });
const account_client = new ApolloClient({
  link: restLink_account,
  cache: new InMemoryCache(),
});

// const LOGIN = gql`
//     query login($email: String!, $password: String!){
//       login(email:$email, password:$password){
//         id
//         token
//       }
//     }
//   `;


const LOGIN = gql`
  query login_insert_cpf($cpf: String!){
    login_insert_cpf(cpf:$cpf){
      id
      token
      error_login_msg
    }
  }
`;

const LOGIN_GOOGLE = gql`
  query login_google($code: String!){
    login_google(code:$code){
      id
      token
    }
  }
`;

class Login extends Component {
  
  state = {
    email: null,
    password: null,
    msg: null,
    msg_type: "info"
  }

  responseGoogleSuccess = async (response) => {

    
    // console.log(response.code);
    /*
    console.log(response.tokenId);
    console.log(response.profileObj.email);
    console.log(response.profileObj.name);
    console.log(response.profileObj.givenName);
   */
  
    const user = (await account_client.query({
      variables: { 
        code: response.code, 
      },
      query: LOGIN_GOOGLE,
      fetchPolicy: 'no-cache'
    })).data.login_google;

    if (user.token !== null) {
      document.cookie = "token_user=" + user.token;// Grava o coookie
      this.setState({
        msg_type: "info",
        msg: "Login feito com sucesso, aguarde, você será redirecionado."
      });
      window.location.replace('/');
    } else {
      this.setState({
        msg_type: "warning",
        msg: "Verifique seu e-mail e senha, e tente novamente."
      });
    }

  }

  // responseGoogleSuccess = async (response) => {

  //   console.log(response.code);
  

    
  //   const user = (await account_client.query({
  //     variables: { 
  //       code: response.code, 
  //     },
  //     query: LOGIN_GOOGLE,
  //     fetchPolicy: 'no-cache'
  //   })).data.login_google;

  //   // console.log(user);
    

  //   if (user.token !== null) {
  //     document.cookie = "token_user=" + user.token;// Grava o coookie
  //     this.setState({
  //       msg_type: "info",
  //       msg: "Login feito com sucesso, aguarde, você será redirecionado."
  //     });
  //     window.location.replace('/');
  //   } else {
  //     this.setState({
  //       msg_type: "warning",
  //       msg: "Verifique seu e-mail e senha, e tente novamente."
  //     });
  //   }
  // }

  responseGoogleFailed = (response) => {


    //console.log(response);
    //console.log("deuruim");


  }

  login = async () => {

    const user = (await account_client.query({
      variables: {cpf: this.state.cpf},
      query: LOGIN,
      fetchPolicy: 'no-cache'
    })).data.login_insert_cpf;
    if(user.token !== null) {
      document.cookie = "token_user="+user.token;// Grava o coookie
      this.setState({
        msg_type: "info",
        msg: "Login feito com sucesso, aguarde, você será redirecionado."
      });
      window.location.replace('/');
    } else {
      this.setState({
        msg_type: "warning",
        msg: user.error_login_msg
      });
    }
  }

  // login = async () => {
  //   const user = (await account_client.query({
  //     variables: {email: this.state.email, password:this.state.password},
  //     query: LOGIN,
  //     fetchPolicy: 'no-cache'
  //   })).data.login;
  //   if(user.token !== null) {
  //     document.cookie = "token_user="+user.token;// Grava o coookie
  //     this.setState({
  //       msg_type: "info",
  //       msg: "Login feito com sucesso, aguarde, você será redirecionado."
  //     });
  //     window.location.replace('/');
  //   } else {
  //     this.setState({
  //       msg_type: "warning",
  //       msg: "Verifique seu e-mail e senha, e tente novamente."
  //     });
  //   }
  // }

  handleSubmit = (event) => {
    event.preventDefault();
    this.login();
  }

  //onChange_email = email => this.setState({ email })

  onChange_email = (event) => {
    this.setState({email: event.target.value});
  }
  onChange_password = (event) => {
      this.setState({password: event.target.value});
  }

  onChange_cpf = (event) => {
    this.setState({cpf: event.target.value});
  }
  

  render() {

    return (
      <div>
        <img className="header_desktop" src={header_desktop} />
        <img className="header_mobile" src={header_mobile} />
        <div className="login-box">
          <p className="">Esta plataforma é exclusiva para as empresas participantes do Programa Na Mão Certa.</p>
          <p className="">
          Se a sua empresa é participante do Programa Na Mão Certa e não tem o acesso, ou se a empresa ainda não faz parte do programa,  entre em contato com a <a href="mailto:atendimento@namaocerta.org.br" target="_bllank">Central de Atendimento</a> : <a href="mailto:atendimento@namaocerta.org.br" target="_bllank">atendimento@namaocerta.org.br</a>
          </p>
        </div>
      </div>
    )


    return (
      <div>
        <img className="header_desktop" src={header_desktop} />
        <img className="header_mobile" src={header_mobile} />
      <div className="login-box">
        
              <form
              onSubmit={e => {
                this.handleSubmit(e);
                e.preventDefault();
              }}
              >

                  {/* <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_cpf,
                        name: "cpf",
                        label: "CPF",
                        // type: "email",
                        bsClass: "form-control",
                        placeholder: "CPF",
                        defaultValue: ""
                      }
                    ]}
                  /> */}

<FormGroup>
                                        <ControlLabel>CPF</ControlLabel>
                                        <div>
                                        <InputMask 
                                          className="form-control"
                                          name="cpf"
                                          mask="999.999.999-99" 
                                          value={this.state.cpf}
                                          onChange={this.onChange_cpf} 
                                        />
                                        </div>
                                      </FormGroup>


                  {/* <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_email,
                        name: "email",
                        label: "E-mail",
                        type: "email",
                        bsClass: "form-control",
                        placeholder: "E-mail",
                        defaultValue: ""
                      }
                    ]}
                  />

                  

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_password,
                        name: "password",
                        label: "Senha",
                        type: "password",
                        bsClass: "form-control",
                        placeholder: "Senha",
                        defaultValue: ""
                      }
                    ]}
                  /> */}

                  <Row>
                    <Col md={3}>
                        <Button bsStyle="info" fill type="submit">
                          ENTRAR
                        </Button>
                    </Col>

                    <Col md={4}>
           
              {/* <GoogleLogin
              // clientId="778876034786-ll2vk348neceuoeo6mm3vpaetr8s2a1t.apps.googleusercontent.com"
              clientId="235255752327-jjcskbchv2m5oks8t5ftfik4jlr1knps.apps.googleusercontent.com"
              buttonText="Login"
              // scope="https://www.googleapis.com/auth/youtube"
              prompt="consent"
              // accessType="offline"
              responseType="code"
              render={renderProps => (
                <Button bsStyle="bg-google info" onClick={renderProps.onClick} disabled={renderProps.disabled} fill type="submit">
                          Logar com o Google
                        </Button>
              )}
              onSuccess={this.responseGoogleSuccess}
              onFailure={this.responseGoogleFailed}
              cookiePolicy={'single_host_origin'}
            /> */}
            </Col>
                    {
                      this.state.msg &&
                      <Col md={10}>
                        <Alert bsStyle={this.state.msg_type}>
                          {this.state.msg}
                        </Alert>
                      </Col>
                    }
                    
                  </Row>

             </form>
      </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Auth/Login.jsx